import { Box } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import BriaButton from "../../../../../../components/common/BriaButton/BriaButton";
import RouterConstants from "../../../../../../constants/RouterConstants";
import useSecureNavigate from "../../../../../../hooks/useSecureNavigate";
import { isLegacyTgRoute } from "../../../../utils/tg-utils.ts";
import styles from "../../TgProjectViewer.module.scss";

const TgProjectModelsEmpty = () => {
	const { t } = useTranslation("tg", { keyPrefix: "models.dashboard" });
	const { projectId } = useParams();
	const navigate = useSecureNavigate();
	return (
		<Box className={styles.emptyState}>
			<Box>{t("emptyState")}</Box>
			<BriaButton
				onClick={() => {
					const base = isLegacyTgRoute()
						? RouterConstants.NEW_TG.LEGACY.PROJECTS.fullPath
						: RouterConstants.NEW_TG.PROJECTS.fullPath;
					return navigate(`${base}/${projectId}/${RouterConstants.NEW_TG.MODELS.createPath}`);
				}}
				buttonType="primaryMedium"
			>
				{t("createModel")}
			</BriaButton>
		</Box>
	);
};

export default observer(TgProjectModelsEmpty);
